/*
 * The link back out of a quest to the site it belongs to.
 *
 * Inside a quest, "/" is the quest's own front page, not Side Quests — each one
 * is served from its own host now. So the "← Side Quests" links cannot be
 * root-relative any more; they have to name the parent host, and the parent
 * host is different in dev (localhost:5173, under starguessr.localhost:5173)
 * than in production. It is read off the address rather than hardcoded so that
 * following it in dev does not silently leave for the live site.
 *
 * Called during prerendering too, where there is no window: the pages that get
 * prerendered are the About pages, and the answer baked into the HTML a crawler
 * reads should be the real public URL regardless.
 */
export const SITE_HOME = 'https://sidequests.space/';

export function homeHref() {
  if (typeof window === 'undefined') return SITE_HOME;

  const { protocol, hostname, port } = window.location;
  const parent = hostname.split('.').slice(1).join('.');

  /*
   * Only a name that could itself be a host counts. Dropping the first label of
   * `sidequests.space` leaves `space`, and of `127.0.0.1` leaves `0.0.1` —
   * neither is anywhere to go, and both mean we are already at the root.
   */
  if (parent !== 'localhost' && !parent.includes('.')) return '/';
  if (/^[\d.]+$/.test(hostname)) return '/';

  return `${protocol}//${parent}${port ? `:${port}` : ''}/`;
}
